//============================
//# sssysisyncstatus
//# Interfész szinkron státusz
//============================

export enum SyncStatus {
    /** Technikai rekord */
    None = 1,
    /** Feldolgozás alatt */
    InProgress = 2,
    /** Feldolgozva */
    Done = 3,
    /** Hiba */
    Error = 4,
    /** Kihagyva */
    Skip = 5,
}

export default interface IfaceSyncStatus {
    id: number;
    name: string;
    foreign: string;
    english: string;
}

export const IfaceSyncStatusDefaultProps: IfaceSyncStatus = {
    id: 1,
    name: '-',
    foreign: '',
    english: '',
}
